
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regions/[slug]",
      function () {
        return require("private-next-pages/regions/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regions/[slug]"])
      });
    }
  